import React from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import { CompanySearchForm } from "./parts/CompanySearchForm";
import { SecuritySelector } from "./parts/SecuritySelector";

export const Disclosures = () => {
  return (
    <ErrorBoundary>
      <h4 className="pl-2 font-weight-lighter mb-3">Disclosures</h4>
      <HeaderImage />
      <CompanySearchForm />
      <SecuritySelector />
    </ErrorBoundary>
  );
};

const HeaderImage = () => (
  <figure className="text-center overflow-hidden mb-0" style={{ height: "80px" }}>
    <img src={`${process.env.PUBLIC_URL}/static/images/disclosures/stairs.jpg`} alt="disclosures img" />
  </figure>
);
